import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { Entry } from 'contentful';

import { MetaService } from '../../services/meta/meta.service';
import { GlobalContentService } from '../../services/global-content/global-content.service';
import { LocalizationService } from '../../services/localization/localization.service';
import { StoreService } from '../../services/store/store.service';
import { AnalyticsService } from '../../services/analytics/analytics.service';
import { Country, DEFAULT_COUNTRY } from '../../interfaces/country';

@Component({
  selector: 'app-test-intro',
  templateUrl: './test-intro.component.html',
  styleUrls: ['./test-intro.component.scss']
})
export class TestIntroComponent implements OnInit {
  public content: Entry<any> | undefined;
  public country: Country | undefined;
  public countries: Array<Country>;
  public globalContent$: Observable<Entry<any>>;
  public consentForm = new FormGroup({
    consent: new FormControl('', [Validators.requiredTrue])
  });

  constructor(
    activatedRoute: ActivatedRoute,
    meta: MetaService,
    private globalContentService: GlobalContentService,
    private localizationService: LocalizationService,
    private store: StoreService,
    private analyticsService: AnalyticsService
  ) {
    this.content = activatedRoute.snapshot.data.content;
    if (this.content && this.content.fields.seo) {
      meta.updateMetaTags(this.content.fields.seo);
    }
  }

  ngOnInit() {
    if (this.store.country.value) {
      this.country = this.store.country.value;
    } else {
      this.country = DEFAULT_COUNTRY;
    }

    this.globalContent$ = this.globalContentService.getGlobalContent();
  }

  get consent() {
    return this.consentForm.get('consent');
  }

  countryChanged(country) {
    this.country = country;
    this.store.country.next(country);
  }

  startTest() {
    if (this.country.country_code === 'fi') {
      this.localizationService.navigate(['test']);
    } else {
      this.analyticsService.startInternationalTest(this.country.country);
      this.localizationService.navigate(['international-test']);
    }
  }
}
